import React from "react";

interface FileFilters {
  includeArchived: boolean;
  category: string | null;
  fileType: string | null;
}

interface FileTypeFilterProps {
  filters: FileFilters;
  onFilterChange: (filters: Partial<FileFilters>) => void;
}

const CATEGORIES = [
  { value: null, label: "Wszystkie kategorie" },
  { value: "offer_attachment", label: "Załączniki do ofert" },
  { value: "brand_asset", label: "Materiały brandowe" },
  { value: "other", label: "Inne" },
];

const FILE_TYPES = [
  { value: null, label: "Wszystkie typy" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel (XLS, XLSX)" },
  { value: "word", label: "Word (DOC, DOCX)" },
];

const FileTypeFilter: React.FC<FileTypeFilterProps> = ({
  filters,
  onFilterChange,
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
      <div className="flex flex-wrap items-center gap-4">
        {/* Category Filter */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Kategoria:
          </label>
          <select
            value={filters.category || ""}
            onChange={(e) =>
              onFilterChange({ category: e.target.value || null })
            }
            className="px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            {CATEGORIES.map((category) => (
              <option
                key={category.value || "all"}
                value={category.value || ""}
              >
                {category.label}
              </option>
            ))}
          </select>
        </div>

        {/* File Type Filter */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Typ pliku:
          </label>
          <select
            value={filters.fileType || ""}
            onChange={(e) =>
              onFilterChange({ fileType: e.target.value || null })
            }
            className="px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            {FILE_TYPES.map((fileType) => (
              <option
                key={fileType.value || "all"}
                value={fileType.value || ""}
              >
                {fileType.label}
              </option>
            ))}
          </select>
        </div>

        {/* Show Archived Toggle */}
        <div className="flex items-center space-x-2">
          <label className="text-sm font-medium text-gray-700">
            Pokaż archiwum:
          </label>
          <input
            type="checkbox"
            checked={filters.includeArchived}
            onChange={(e) =>
              onFilterChange({ includeArchived: e.target.checked })
            }
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
        </div>
      </div>
    </div>
  );
};

export default FileTypeFilter;
